import {
  TextField,
  FormControl,
  NativeSelect,
  InputLabel,
} from "@mui/material";
import React, { useState, ChangeEvent } from "react";
import dropdown from "../../ressources/images/dropdown.svg";
import styles from "./uncontrolledStyles";

export interface DropdownItem {
  key: string | number;
  text: string;
  value: string | number;
  simpleField?: boolean;
  size?: number;
}

export interface IProps {
  id?: string;
  disabled?: boolean;
  value?: string;
  label: string;
  options: DropdownItem[];
  readOnly?: boolean;
  required?: boolean;
  placeholder?: string;
  handleChange?: (id: string | undefined, value: string) => void;
}

const svgIcon = (props: any) => <img src={dropdown} {...props} alt="" />;

const UncontrolledSelect: React.FC<IProps> = ({
  id,
  disabled = false,
  value = "",
  label,
  options,
  readOnly = false,
  required = false,
  placeholder = "",
  handleChange,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | number>(value);
  if (value && options.length > 0) {
    const findOption = options.filter((o) => o.value === value).length > 0;
    if (!findOption) {
      value = "";
    }
  }
  const onChange = (e: { target: { value: string } }) => {
    const newValue = e.target.value;
    setSelectedValue(newValue);
    if (handleChange) {
      handleChange(id, newValue);
    }
  };

  return (
    <FormControl className="root" sx={styles}>
      <InputLabel htmlFor={id || "select-native"} className="textFieldLabel">
        {label}
      </InputLabel>

      <NativeSelect
        id={id || "select-native"}
        value={selectedValue}
        onChange={onChange}
        required={required}
        disabled={disabled || readOnly}
        inputProps={{
          className: "textFieldRoot",
        }}
        // input={
        //   <TextField
        //     InputProps={{
        //       className: "underline",
        //     }}
        //     InputLabelProps={{
        //       className: "textFieldLabel",
        //     }}
        //   />
        // }
        variant="filled"
        className="textFieldRoot"
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.key} value={option.value}>
            {option.text}
          </option>
        ))}
      </NativeSelect>
      {/* <TextField
        id={id}
        select
        label={label}
        value={selectedValue}
        onChange={onChange}
        required={required}
        disabled={disabled || readOnly}
        InputProps={{
          className: "underline",
        }}
        SelectProps={{
          native: true,
          IconComponent: svgIcon,
          className: "select",
        }}
        InputLabelProps={{
          className: "textFieldLabel",
        }}
        variant="filled"
        className="textFieldRoot"
      >
        <option disabled value="">
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.key} value={option.value}>
            {option.text}
          </option>
        ))}
      </TextField> */}
    </FormControl>
  );
};

export default UncontrolledSelect;
